import { Expression } from "./abstract.expression";

export class CountExpression extends Expression 
{
    toQuery(): string 
    {
        return "$count=true";
    }
}
